import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import bgImage from "assets/images/admin.png";
import { CopyToClipboard } from "react-copy-to-clipboard";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import { useTranslation } from "react-i18next";
// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
// Images
//import bgImage from "assets/images/strategia.jpg";
import { Card, CardContent, Typography, Button, TextField } from "@mui/material";
//import RotatingCard from "./RotatingCard";
//import RotatingCardFront from "./RotatingCardFront";
//import RotatingCardBack from "./RotatingCardBack";
//import { useTranslation } from "react-i18next";
//import bgFront from "assets/images/rotating-card-bg-front.jpeg";
//import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import { FormControl, Select, MenuItem } from "@mui/material";
// eslint-disable-next-line
import { GET_RAG } from "queries";
//import { useQuery } from "@apollo/client";
// eslint-disable-next-line
import { useLazyQuery } from "@apollo/client";
//import { useMutation } from "@apollo/client";
//import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
import ReCAPTCHA from "react-google-recaptcha";
//import Box from "@mui/material/Box";
//import Slider from "@mui/material/Slider";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Idecide = ({ selectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  const [idea, setIdea] = useState("");
  //const [name, setName] = useState("");
  //const [born, setBorn] = useState("");
  //const [gender, setGender] = useState("");
  const [model, setModel] = useState("");
  // eslint-disable-next-line
  const [modeltext, setModeltext] = useState("");
  // eslint-disable-next-line
  const [query, setQuery] = useState("");
  // eslint-disable-next-line
  const [sources, setSources] = useState([]);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  // eslint-disable-next-line
    const [submitted, setSubmitted] = useState(false);
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideas, setIdeas] = useState([]);
  // eslint-disable-next-line
  const [ideatext, setIdeatext] = useState("");
  const [selectedIdea, setSelectedIdea] = useState("");
  // eslint-disable-next-line
  const [votes, setVotes] = useState([]);
  //const [token, setTokeni] = useState("");
  ////console.log(token);
  // eslint-disable-next-line
  const [scomments, setScomments] = useState([]);
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = "anonym";
    if (localStorage.getItem("id") !== undefined) {
      id = localStorage.getItem("id");
    }
    //console.log(id);
    ReactGA.event({
      category: "Idecide",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,
    }); // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });*/
    //console.log(cat);
  }, []);
  /*const scommentssw = useQuery(FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  */
  // eslint-disable-next-line
  const [getPost, { data }] = useLazyQuery(GET_RAG);
  /*const getRag = useQuery(GET_RAG, {
    variables: { text: idea, model: model, count: 3 },
  });*/
  useEffect(() => {
    console.log(data);
    if (data?.getRag) {
      //setSelectedPost(data.post);
      console.log(data.getRag);
      let text = data.getRag.message;
      let query = text.split(',"answer":"');
      //setOrgans(organss);
      console.log(query);
      setQuery(query[1].split('","sources":')[0]);
      //let secs = scommentss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setscomments(secs);
      setModeltext(text.split(',"answer":"')[0].split('model":"')[1].split('"')[0]);
      setIdeatext(data.getRag.message);
      setSources(query[1].split('","sources":')[1].split("}")[0].split('","'));

      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [data]);
  const handleSubmit = async () => {
    //event.preventDefault();
    //const aika = Date.now();
    //const pvm = new Date(aika);
    getPost({ variables: { text: idea, model: model, count: 3 } });
    setSelectedIdea("");
    window.confirm("Luominen alkoi");
    setVerified(!verified);
  };

  const handleStart = () => {
    //event.preventDefault();
    //const aika = Date.now();
    //const pvm = new Date(aika);
    getPost({ variables: { text: "ok", model: 1, count: 1 } });
  };

  /*useEffect(() => {
    let filtered = categ.filter((cont) => {
      return cont.name === selectedIdea;
    });
    //console.log(selectedIdea);
    //console.log(filtered);
    if (filtered.length > 0) {
      setIdeatext(filtered[0].text);
    }
  }, [selectedIdea]);
  const getAiheet = () =>
    categ.map((aihe) => {
      return (
        <MenuItem value={aihe.name} key={aihe.name}>
          {aihe.name}
        </MenuItem>
      );
    });
*/
  /*const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategycommentid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  */
  /*const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }
  });
  */
  /*useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategycommentid === p).length;
  }*/
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 250px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={16} lg={15} justifyContent="center" mx="auto">
            <Card style={{ marginBottom: "1rem" }}>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  {selectedIdea}
                </Typography>
                <h2>{t("rag.create")}</h2>
                <Button variant="outlined" style={{ color: "red" }} onClick={handleStart}>
                  {t("rag.start")}
                </Button>
                <br />
                <FormControl style={{ minWidth: 220 }}>
                  {t("rag.model")}
                  <Select
                    labelId="Model"
                    id="model"
                    value={model}
                    onChange={({ target }) => setModel(target.value)}
                  >
                    <MenuItem selected value={1}>
                      openai/gpt-oss-120b
                    </MenuItem>
                    <MenuItem value={2}>groq/compound-mini</MenuItem>
                    <MenuItem value={6}>moonshotai/kimi-k2-instruct</MenuItem>
                    <MenuItem value={7}>qwen/qwen3-32b</MenuItem>
                    <MenuItem value={8}>llama-3.1-8b-instant</MenuItem>
                    <MenuItem value={9}>openai/gpt-oss-20b</MenuItem>
                    <MenuItem value={10}>gemma2-9b-it</MenuItem>
                    <MenuItem value={11}>moonshotai/kimi-k2-instruct-0905</MenuItem>
                    <MenuItem value={14}>meta-llama/llama-4-maverick-17b-128e-instruct</MenuItem>
                    <MenuItem value={15}>meta-llama/llama-4-scout-17b-16e-instruct</MenuItem>
                    <MenuItem value={18}>deepseek-r1-distill-llama-70b</MenuItem>
                    <MenuItem value={20}>llama-3.3-70b-versatile</MenuItem>
                  </Select>
                </FormControl>
                <br />
                <br />
                <Typography variant="h6" gutterBottom>
                  {t("rag.text")}
                </Typography>
                <TextField
                  label={t("rag.label")}
                  multiline
                  fullWidth
                  minRows={3}
                  value={idea}
                  onChange={(e) => setIdea(e.target.value)}
                  variant="outlined"
                  style={{ marginBottom: "0.5rem" }}
                />
                <br />
                <br />
                <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
                <br />
                <br />
                <Button
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={handleSubmit}
                  disabled={!verified}
                  submitted={submitted}
                >
                  {t("rag.createtext")}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Container>
      </MKBox>
      <MKBox pt={2} px={2} mt={2}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <Card key="1" style={{ marginBottom: "0.5rem" }}>
              <MKTypography variant="h4" gutterBottom>
                Päätöstekstit
              </MKTypography>
              <br />
              <br />
              <CardContent
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <MKTypography>
                  LUOTU TEKSTI:
                  <br />
                  <br />
                  {query}
                  <br />
                  <br />
                  LÄHTEET:
                  <br />
                  <br />
                  {sources.map((item, index) => (
                    <Card key={index} style={{ marginBottom: "0.5rem" }}>
                      <CardContent
                        style={{
                          alignItems: "center",
                          width: "500px",
                        }}
                      >
                        {index}: {item}
                        <br />
                        <br />
                      </CardContent>
                    </Card>
                  ))}
                  <br />
                  <br />
                  MALLI:
                  <br />
                  <br />
                  {modeltext}
                </MKTypography>
                <CopyToClipboard text={query}>
                  <Button variant="contained" style={{ color: "white" }}>
                    Kopioi
                  </Button>
                </CopyToClipboard>
              </CardContent>
            </Card>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Idecide;
